
export function generateFormErrors(errorMessage) {
  const results = {};
  const errors = errorMessage.response.data.fields;
  const keys = Object.keys(errors);

  // eslint-disable-next-line no-return-assign
  keys.forEach(key => results[key] = errors[key]);

  return results;
}
